import { SITE_VARIABLES } from '../../../../common/styles/variables';
import { PlayerSizesTypes } from '../../../../common/store/store.types';

interface StylesObject {
  currentTimeAndDurationStyle: { [key: string]: any };
}

const currentTimeAndDuration = {
  display: 'grid',
  position: 'relative',
  order: '2',
  width: 'fit-content',
  color: SITE_VARIABLES.COLORS.WHITE,
  fontFamily: SITE_VARIABLES.TEXT_FONT_FAMILY.LATO,
  fontWeight: '300',
  marginLeft: '8px',
  medium: {
    fontSize: SITE_VARIABLES.FONT_SIZE.TINY,
  },
  largeAndExtraLarge: {
    fontSize: SITE_VARIABLES.FONT_SIZE.EXTRA_SMALL,
  },
};

export const getCurrentTimeAndDurationStyleObject = (playerSize: PlayerSizesTypes): StylesObject => {
  const mediumSize = playerSize === 'medium';
  const largeAndExtraLargeSize = playerSize === 'large' || playerSize === 'extraLarge';

  return ({
    currentTimeAndDurationStyle: [
      currentTimeAndDuration,
      mediumSize && currentTimeAndDuration.medium,
      largeAndExtraLargeSize && currentTimeAndDuration.largeAndExtraLarge,
    ],
  });
};
